
    import '/vercel/path0/docs/changelog.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/changelog.md?type=demo')
};